// 语言资源索引文件
import zh from './zh.js';
import en from './en.js';

export default {
  zh,
  en
};